import React from "react";

interface ITextIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const TextIcon: React.FC<ITextIconProps> = ({ sizeX = 25, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5 6H3.5M10.5 12H3.5M10.5 18H3.5" stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.5 12.5V11H21.5V12.5M16 19H19M17.5 11V19" stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

